import { ThankYouSplash } from '@/components/interview/ThankYouSplash'
import { useInterviewSessionContext } from '@/context/InterviewSessionContext'
import { useInterviewStore } from '@/store/interviewStore'

export function ThankYouScreen() {
  const { language, loadedConfig, redirectUrl, handleBackToHome } = useInterviewSessionContext()
  const aborted = useInterviewStore((s) => s.aborted)

  return (
    <ThankYouSplash
      language={language}
      isDemoMode={loadedConfig?.mode === 'demo'}
      aborted={aborted}
      redirectUrl={redirectUrl}
      onHome={handleBackToHome}
    />
  )
}
